var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowN = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 10,
  viewBox: "0 0 8 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M5 3.33v6.634H3V3.33L1.5 5.464H.992A.99.99 0 0 1 0 4.471v-.508L3.321.31a.897.897 0 0 1 1.358 0L8 3.963v.508a.99.99 0 0 1-.992.993H6.5z"
})));
export default SvgArrowN;